import { AxiosError } from 'axios';
import resources from '../../resources';

export interface IChangePassword {
  currentPassword: string;
  newPassword: string;
}

export const PROFILE_PASSWORD_SAVING = 'USERS/PROFILE_PASSWORD_SAVING';
export const PROFILE_PASSWORD_SAVE_SUCCESS =
  'USERS/PROFILE_PASSWORD_SAVE_SUCCESS';
export const PROFILE_PASSWORD_SAVE_FAILURE =
  'USERS/PROFILE_PASSWORD_SAVE_FAILURE';
export function changePassword(data: IChangePassword) {
  return (dispatch) => {
    dispatch({ type: PROFILE_PASSWORD_SAVING });

    return resources.auth.password
      .put(data.currentPassword, data.newPassword)
      .then(() => dispatch({ type: PROFILE_PASSWORD_SAVE_SUCCESS }))
      .catch((error: AxiosError) =>
        dispatch({ type: PROFILE_PASSWORD_SAVE_FAILURE, error })
      );
  };
}
